// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили для хедера и сайдбара */
.Layout_ant-layout-header__e0eK9 {
  line-height: normal !important;
  height: auto !important;
  padding: 16px 24px !important;
}

/* Анимация для иконок */
.Layout_anticon__NUTq1 {
  transition: color 0.3s;
}

.Layout_anticon__NUTq1:hover {
  color: #1890ff !important;
}

/* Стили для выпадающего меню пользователя */
.Layout_ant-dropdown-menu__nEdWt {
  border-radius: 8px !important;
  padding: 8px 0 !important;
}

/* Стили для бейджа уведомлений */
.Layout_ant-badge-count__nhGgl {
  box-shadow: none !important;
  font-size: 10px !important;
  min-width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
}

/* Адаптивные стили */
@media (max-width: 768px) {
  .Layout_ant-layout-sider__5Lk4R {
    position: fixed !important;
    z-index: 100;
    height: 100vh;
  }

  .Layout_ant-layout-content__oP-n8 {
    margin-left: 0 !important;
    padding: 24px 16px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.module.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;AACF","sourcesContent":["/* Общие стили для хедера и сайдбара */\n.ant-layout-header {\n  line-height: normal !important;\n  height: auto !important;\n  padding: 16px 24px !important;\n}\n\n/* Анимация для иконок */\n.anticon {\n  transition: color 0.3s;\n}\n\n.anticon:hover {\n  color: #1890ff !important;\n}\n\n/* Стили для выпадающего меню пользователя */\n.ant-dropdown-menu {\n  border-radius: 8px !important;\n  padding: 8px 0 !important;\n}\n\n/* Стили для бейджа уведомлений */\n.ant-badge-count {\n  box-shadow: none !important;\n  font-size: 10px !important;\n  min-width: 16px !important;\n  height: 16px !important;\n  line-height: 16px !important;\n}\n\n/* Адаптивные стили */\n@media (max-width: 768px) {\n  .ant-layout-sider {\n    position: fixed !important;\n    z-index: 100;\n    height: 100vh;\n  }\n\n  .ant-layout-content {\n    margin-left: 0 !important;\n    padding: 24px 16px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ant-layout-header": `Layout_ant-layout-header__e0eK9`,
	"anticon": `Layout_anticon__NUTq1`,
	"ant-dropdown-menu": `Layout_ant-dropdown-menu__nEdWt`,
	"ant-badge-count": `Layout_ant-badge-count__nhGgl`,
	"ant-layout-sider": `Layout_ant-layout-sider__5Lk4R`,
	"ant-layout-content": `Layout_ant-layout-content__oP-n8`
};
export default ___CSS_LOADER_EXPORT___;
